//tslint:disable:export-name
export { ProductUgcService } from './service-setup/ProductUgcService';
import { diContainer, serviceNames } from './service-setup/diContainer';
import { setupServiceInfo } from 'elc-universal-utils';

diContainer.get(serviceNames.productUgcService).register();

setupServiceInfo(__serviceInfo__);
